import styled from 'styled-components';

interface TooltipProps {
  marginLeft: string;
}

export const Tooltip = styled.div<TooltipProps>`
  position: relative;
  display: inline-block;
  align-self: center;
  margin-left: ${({ marginLeft }) => marginLeft};
  text-align: center;

  &:hover .tooltipText {
    visibility: visible;
    opacity: 1;
  }

  svg {
    color: ${({ theme }) => theme.colors.secondaryBlue.main};
    font-size: 16px;
    display: block !important;
    margin: auto !important;

    &:hover {
      cursor: pointer;
    }
  }


`;

export const TooltipText = styled.div<{position: string}>`
  visibility: hidden;
  width: 200px;
  background-color: ${({ theme }) => theme.colors.primaryBlue.main};
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 10px;
  position: absolute;
  z-index: 100;
  opacity: 0;
  transition: opacity 0.3s;


  ${({ position }) => position === 'top' && `
    bottom: 125%;
    left: 50%;
    margin-left: -100px;
  `}

  ${({ position }) => position === 'right' && `
    top: 50%;
    left: 100%;
    margin-top: -20px;
  `}

  ${({ position }) => position === 'bottom' && `
    top: 125%;
    left: 50%;
    margin-left: -100px;
  `}

  ${({ position }) => position === 'left' && `
    top: 50%;
    right: 100%;
    margin-top: -20px;
  `}
`;